export default function Awards() {
  return (
    <section id="premiacoes" className="py-16 sm:py-20 bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 sm:mb-6">
            Premiações
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Campeonato de Pilotos */}
          <div className="bg-gray-800 p-8 rounded-xl border-2 border-orange-500">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 flex items-center justify-center bg-orange-500 rounded-lg mr-4">
                <i className="ri-trophy-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold">Campeonato de Pilotos</h3>
            </div>
            <div className="space-y-4">
              <div className="flex items-center">
                <span className="text-4xl mr-4">🥇</span>
                <div>
                  <p className="text-xl font-bold">1º Lugar</p>
                  <p className="text-gray-400">Troféu de Campeão</p>
                </div>
              </div>
              <div className="flex items-center">
                <span className="text-4xl mr-4">🥈</span>
                <div>
                  <p className="text-xl font-bold">2º Lugar</p>
                  <p className="text-gray-400">Troféu de Vice-Campeão</p>
                </div>
              </div>
              <div className="flex items-center">
                <span className="text-4xl mr-4">🥉</span>
                <div>
                  <p className="text-xl font-bold">3º Lugar</p>
                  <p className="text-gray-400">Troféu de 3º Colocado</p>
                </div>
              </div>
            </div>
          </div>

          {/* Série A */}
          <div className="bg-gray-800 p-8 rounded-xl border-2 border-orange-500">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 flex items-center justify-center bg-orange-500 rounded-lg mr-4">
                <i className="ri-money-dollar-circle-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold">Série A</h3>
            </div>
            <div className="space-y-4">
              <p className="text-lg text-gray-300 leading-relaxed">
                Premiação em dinheiro para os melhores colocados da Série A.
              </p>
              <div className="bg-orange-500/10 border-l-4 border-orange-500 p-4 rounded">
                <p className="text-base text-gray-300">
                  <strong className="text-orange-500">Detalhes completos:</strong> valores e critérios disponíveis no Regulamento Oficial do grupo do campeonato.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
